import { keyframes } from "styled-components"

export const FadeIn = keyframes`
 {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`

export const FadeInBottom = keyframes`
 {
  0% {
    transform: translateY(50px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

`
